import React, { useEffect } from 'react'
import loadScript from 'src/lib/loadScript'
import { SocialFeedHeading, SocialFeedWidget } from './styled'

const ELFSIGHT_PLATFORM_URL = 'https://elfsightcdn.com/platform.js'
const ELFSIGHT_APP_CLASS = 'elfsight-app-d24c3cfb-b1fd-41cd-996e-7a119b316218'

function SocialFeed() {
	useEffect(() => {
		if (document.querySelector(`script[src="${ELFSIGHT_PLATFORM_URL}"]`)) return
		loadScript(ELFSIGHT_PLATFORM_URL, { async: true }).catch(() => {
			/* the feed simply stays empty if the Elfsight platform fails to load */
		})
	}, [])

	return (
		<>
			<SocialFeedHeading>What’s new on social media?</SocialFeedHeading>
			<SocialFeedWidget>
				<div className={ELFSIGHT_APP_CLASS} data-elfsight-app-lazy />
			</SocialFeedWidget>
		</>
	)
}

export default SocialFeed
